import { RedirectState, useCurrentCompany, useCompanyInformation } from '@neo.tax/shared';

export const useAscDataSourcesRedirect = (): RedirectState => {
  const { loading: loadingCompanyInformation } = useCompanyInformation();
  const { loading: loadingCompany } = useCurrentCompany();

  const isLoading = loadingCompanyInformation || loadingCompany;
  return { isLoading };
};
